import { VersionGroupModel } from "@/services";
import { Vue, Component, Watch } from "vue-property-decorator";
import ChildNavigation from "@/components/navigation/child-navigation/child-navigation.vue";
import { ApplicationViews } from "@/util/enum";
import { sortBy } from "lodash";
import { ReportsModule } from "@/modules/reports-objective";
import { getModule } from "vuex-module-decorators";
import AppSettings from "@/modules/app-settings";
import ScopeHeaderActions from "./components/scope-header-actions/scope-header-actions.vue";
import VersionGroupSingleUnit from "@/components/version-group-single-unit/version-group-single-unit.vue";
import TeachingPlanHeaderActions from "./components/teachingplan-header-actions/teachingplan-header-actions.vue";
import VpcOverviewHeaderActions from "./components/vpcoverview-header-actions/vpcoverview-header-actions.vue";
import UnitOverviewHeaderActions from "./components/unitoverview-header-actions/unitoverview-header-actions.vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import { fmtMsg } from "commonui";
import { isAnyVersionSelected } from "@/util/func";
import { CommonLocale } from "@/locales/localeid";
import { Alert } from "ant-design-vue";
import PageTitle from "@/components/page-title/page-title.vue";
import { ReportsLocale } from "@/locales/localeid";
import ComponentObjectiveHeaderActions from "./components/component-objective-header-actions/component-objective-header-actions.vue";
import FocusWordsByChapterHeaderActions from "./components/focus-words-chapter-header-actions/focus-words-chapter-header-actions.vue";
import MasteryQuestionObjectiveHeaderActions from "./components/mastery-question-objective-header-actions/mastery-question-objective-header-actions.vue";
import MediaChangeImpactHeaderActions from "./components/media-change-impact-header-actions/media-change-impact-header-actions.vue";

@Component({
	components: {
		ChildNavigation,
		ScopeHeaderActions,
		VersionGroupSingleUnit,
		TeachingPlanHeaderActions,
		VpcOverviewHeaderActions,
		UnitOverviewHeaderActions,
		ComponentObjectiveHeaderActions,
		FocusWordsByChapterHeaderActions,
		MasteryQuestionObjectiveHeaderActions,
		MediaChangeImpactHeaderActions,
		Alert,
		PageTitle
	}
})
export default class Reports extends Vue {
	public view = ApplicationViews.Reports;
	public ApplicationViews = ApplicationViews;
	private versionGroupModule = VersionGroupModule;
	public appSetting = getModule(AppSettings) as AppSettings;
	public commonLocale = CommonLocale;
	public noVersion: boolean = false;
	public reportsLocale = ReportsLocale;

	created() {
		if (!isAnyVersionSelected()) {
			this.noVersion = true;
		}
	}

	@Watch("versionGroupModule.selectedGsVersion")
	@Watch("versionGroupModule.selectedLsVersion")
	isVersionUpdated() {
		if (isAnyVersionSelected()) {
			this.noVersion = false;
		} else {
			this.noVersion = true;
		}
	}

	@Watch("versionGroupModule.selectedGsVersion", { immediate: true })
	@Watch("versionGroupModule.selectedLsVersion", { immediate: true })
	setVersionGroup() {
		const versionGroupId =
			 this.versionGroupModule.selectedGsVersion !== "-1"
				? this.versionGroupModule.selectedGsVersion
				: this.versionGroupModule.selectedLsVersion;
		const versionGroup = this.versionGroupModule.versionGroups.find(v => v.id == versionGroupId);
		ReportsModule.setVersionGroup(versionGroup as VersionGroupModel);
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	mounted() {
		this.versionGroupModule.setDisabled(false);
	}
	destroyed() {
		this.versionGroupModule.setDisabled(true);
	}
	get childMenuSelected() {
		return this.appSetting.childMenuSelected;
	}

	disablePath(path: string) {
		return false;
	}

	get vcsLevelUnits() {
		return sortBy(ReportsModule.vcsUnits, "unit");
	}
}
